export const groupedPreviewRailStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  flexWrap: 'wrap',
};

export const groupedPreviewPartStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
};

export const groupedPreviewPartLabelStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '120px',
};
